import request from '@/utils/request'

const SIMULATION_GAME = '/exam'

// 赛场列表
export function getExamGroundList(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_list',
		method: 'get',
		params
	})
}

// 比赛报名
export function application(data) {
	return request({
		url: SIMULATION_GAME + '/application',
		method: 'post',
		data
	})
}

// 进入比赛或获取比赛题目
export function getExamGroundInfo(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_info',
		method: 'get',
		params
	})
}

// 提交题目答案
export function submitProblem(data) {
	return request({
		url: SIMULATION_GAME + '/submit_problem',
		method: 'post',
		data
	})
}

// 交卷
export function submitExamGround(data) {
	return request({
		url: SIMULATION_GAME + '/submit_exam_ground',
		method: 'post',
		data
	})
}

// 获取当前时间
export function getTime(params) {
	return request({
		url: SIMULATION_GAME + '/get_time',
		method: 'get',
		isLoading: false,
		params
	})
}





// 查看比赛结果
export function getExamGroundUserResult(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_user_result',
		method: 'get',
		params
	})
}

// 获取排名
export function getRankList(params) {
	return request({
		url: SIMULATION_GAME + '/rank_list',
		method: 'get',
		params
	})
}

// 获取题目列表
export function getExamGroundProblemFinish(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_problem_finish',
		method: 'get',
		params
	})
}

// 查看比赛答题信息
export function getExamGroundUserFinish(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_user_finish',
		method: 'get',
		params
	})
}

// 获取单个比赛状态
export function examGroundStatus(params) {
	return request({
		url: SIMULATION_GAME + '/exam_ground_status',
		method: 'get',
		params
	})
}

// 判断是否有进行中的比赛
export function hasInProgressExamGround(params) {
	return request({
		url: SIMULATION_GAME + '/has_in_progress_exam_ground',
		method: 'get',
		params
	})
}
